exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.jsoneditor {\n  border: 1px solid #9e9e9e;\n}\ndiv.jsoneditor-menu {\n  background-color: #9e9e9e;\n  border-bottom: 1px solid #9e9e9e;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53ffe244","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/cerebro/entities/Index.vue
// module id = 856
// module chunks = 1